import { render, staticRenderFns } from "./FrequentlyAsked.vue?vue&type=template&id=7efe6f31&scoped=true&"
import script from "./FrequentlyAsked.vue?vue&type=script&lang=js&"
export * from "./FrequentlyAsked.vue?vue&type=script&lang=js&"
import style0 from "./FrequentlyAsked.vue?vue&type=style&index=0&id=7efe6f31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efe6f31",
  null
  
)

export default component.exports